import React from "react";
const NotFound = (props) => {
  return <div>Not Found</div>;
};
export default NotFound;
